module.exports = __webpack_public_path__ + "assets/teethLower.71ce705ff1ee69bde9250a53bfe37542.png";